import React, { useState } from 'react';
import ModalDetailSyncDataComponent from '../Component/ModalDetailSyncDataComponent';
import { useMutation, useQuery } from '@tanstack/react-query';
import { getDetailSyncDataDelivery, mutateDownloadSyncData } from 'services/SyncDataServices';
import { Modal } from 'antd';
import { downloadBlob } from 'lib/util';
import { AxiosError } from 'axios';
import moment from 'moment';

export default function ModalDetailSyncDataContainer(props: any) {
  const {
    modalDetailSyncData,
    setModalDetailSyncData,
    detailSyncData = null,
    setDetailSyncData,
  } = props;
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [currentSize] = useState<number>(10);
  const {
    data: detailSyncDataTable,
    isFetching: isFetchingDetailSyncDataTable,
  } = useQuery(
    ['detailSyncData', detailSyncData?.id, currentPage, currentSize],
    getDetailSyncDataDelivery,
    {
      enabled: detailSyncData !== null,
    }
  );
  //console.log('detailSyncDataTable', detailSyncDataTable);
  const handleCancel = () => {
    setModalDetailSyncData(false);
    setDetailSyncData(null);
  };

  const mutateDownloadReport = useMutation({
    mutationFn: mutateDownloadSyncData,

    onSuccess(res) {
      const customer = detailSyncData?.customer;
      const customerProduct = detailSyncData?.customerProduct;
      const currentDate = moment().format('DD-MM-YYYY');
      downloadBlob(res.data, `Data Sync API_${customer}_${customerProduct}_${currentDate}`, 'xls');
    },

    onError: async (error: unknown) => {
      let msg =
        'Terjadi kesalahan pada server, mohon hubungi admin untuk tindakan lebih lanjut';

      const err = error as AxiosError;

      if (err?.response) {
        const { data, statusText } = err.response;

        try {
          if (data instanceof Blob) {
            const text = await data.text();
            try {
              const json = JSON.parse(text);
              msg = (json as any)?.Message || (json as any)?.message || text;
            } catch {
              msg = text || msg;
            }
          } else if (typeof data === 'object' && data) {
            msg = (data as any).Message || (data as any).message || statusText || msg;
          } else if (typeof data === 'string') {
            msg = data;
          }
        } catch {
          // ignore parsing errors
        }
      }

      Modal.error({
        title: <b style={{ color: '#EA1A1A' }}>Gagal menjalankan proses</b>,
        content: <p style={{ color: '#C0C0C0' }}>{msg}</p>,
      });
    },
  });

  // === FIXED HANDLE DOWNLOAD ===
  const handleDownload = () => {
    const id = detailSyncData?.id;

    if (!id) {
      Modal.warning({
        title: 'Data tidak valid',
        content: 'ID tidak ditemukan.',
      });
      return;
    }

    mutateDownloadReport.mutate({
      id,
    });
  };

  const columnData = [
    {
      title: (
        <div style={{ textAlign: 'center' }}>
          <b>No</b>
        </div>
      ),
      render: (_text, _record, index) => (
        <span>
          {currentPage > 0 ? index + (currentPage * 10 + 1) : index + 1}
        </span>
      ),
      key: 'no',
      width: 10,
    },
    {
      title: <b>Waybill</b>,
      dataIndex: 'waybillCode',
      key: 'waybillCode',
      width: 80,
    },
    {
      title: <b>Tanggal Selesai Kirim</b>,
      dataIndex: 'deliveryFinishedDate',
      key: 'deliveryFinishedDate',
      width: 30,
    },
    {
      title: <b>Status Detail</b>,
      render: row => {
        const { syncDataDeliveryStatus, messageError } = row;
        return (
          <span
            style={{
              color:
                syncDataDeliveryStatus === 'Error'
                  ? '#EA1A1A'
                  : syncDataDeliveryStatus === 'OnProcess'
                  ? '#ECA722'
                  : syncDataDeliveryStatus === 'Success'
                  ? '#00AB44'
                  : '',
            }}
          >
            {syncDataDeliveryStatus === 'Error'
              ? messageError
              : syncDataDeliveryStatus === 'OnProcess'
              ? 'Dalam Proses'
              : syncDataDeliveryStatus === 'Success'
              ? 'Successful'
              : ''}
          </span>
        );
      },
      width: 80,
    },
  ];

  return (
    <ModalDetailSyncDataComponent
      modalDetailSyncData={modalDetailSyncData}
      handleCancel={handleCancel}
      handleDownload={handleDownload}
      detailSyncData={detailSyncData}
      detailSyncDataTable={detailSyncDataTable?.data || []}
      isFetchingDetailSyncDataTable={isFetchingDetailSyncDataTable}
      currentPage={currentPage}
      totalDatas={detailSyncDataTable?.totalDatas || 0}
      totalPages={detailSyncDataTable?.totalPages || 0}
      setCurrentPage={setCurrentPage}
      columnData={columnData}
    />
  );
}
